import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { advanceFlow, closeBirthChartFlow, getBirthChartFlow, patchFlowDetails } from '../../../../store/slices/birthChartSlice';
import { gaEvents } from '../../../../utils/analytics';
import BirthDatePicker, { MONTHS, clampDay } from '../../../common/BirthDatePicker';
import Button, { BUTTON_STYLE_TYPE } from '../../../common/Button';
import Sheet from './Sheet';
import { firstMissingStep, parseBirthDate, toBirthDateString } from './flowLogic';
import styles from './styles.module.scss';

const DateSheet = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { details } = useSelector(getBirthChartFlow);

    const initial = useMemo(() => {
        const parts = parseBirthDate(details.birthDate);
        if (parts) return { month: MONTHS[parts.month - 1], day: parts.day, year: parts.year };
        // Nothing yet: start near a young adult so the year wheel is not a long scroll.
        const today = new Date();
        return { month: MONTHS[today.getMonth()], day: today.getDate(), year: today.getFullYear() - 25 };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [month, setMonth] = useState(initial.month);
    const [day, setDay] = useState(initial.day);
    const [year, setYear] = useState(initial.year);

    const handleContinue = () => {
        const monthIndex = MONTHS.indexOf(month);
        const birthDate = toBirthDateString({ year, month: monthIndex + 1, day: clampDay(day, monthIndex, year) });
        dispatch(patchFlowDetails({ birthDate }));
        gaEvents.bcStepCompleted('date');
        dispatch(advanceFlow(firstMissingStep({ ...details, birthDate })));
    };

    return (
        <Sheet
            title={t('birthChart.flow.date.title')}
            onClose={() => dispatch(closeBirthChartFlow())}
            closeLabel={t('birthChart.flow.close')}
        >
            <BirthDatePicker month={month} day={day} year={year} onMonthChange={setMonth} onDayChange={setDay} onYearChange={setYear} />
            <Button
                styleType={BUTTON_STYLE_TYPE.PURPLE}
                extraClasses={[styles.cta]}
                text={t('birthChart.flow.continue')}
                onClick={handleContinue}
            />
        </Sheet>
    );
};

export default DateSheet;
